import LoopSlider from "./LoopSlider";
import Swiper from "swiper";
import { Pagination, Autoplay, Grid, Navigation, Thumbs } from "swiper/modules";

let homeBannerThumbSlider = new Swiper(".home-banner-thumb-slider .swiper", {
	slidesPerView: 2.5,
	spaceBetween: 8,
	loop: true,
	watchSlidesVisibility: true,
	watchSlidesProgress: true,
	breakpoints: {
		576: {
			spaceBetween: 20,
			slidesPerView: 2.5,
		},
		1024: {
			spaceBetween: 20,
			slidesPerView: 3,
		},
	},
});

let homeBannerSlider = new Swiper(".home-banner-slider .swiper", {
	modules: [Autoplay, Thumbs, Navigation],
	slidesPerView: 1,
	spaceBetween: 12,
	loop: true,
	autoplay: {
		delay: 4000,
	},
	thumbs: {
		swiper: homeBannerThumbSlider,
	},
	navigation: {
		nextEl: ".home-banner-thumb-slider .swiper-btn-next",
		prevEl: ".home-banner-thumb-slider .swiper-btn-prev",
	},
});

const partner3RowSlider = new Swiper(".partner-3-rows-slider .swiper", {
	modules: [Grid, Navigation],
	slidesPerView: 2.5,
	spaceBetween: 20,
	grid: {
		rows: 3,
		fill: "row",
	},
	breakpoints: {
		576: {
			slidesPerView: 4.5,
		},
		768: {
			slidesPerView: 5.5,
		},
		1024: {
			slidesPerView: 6,
			spaceBetween: 40,
		},
	},
	navigation: {
		nextEl: ".partner-3-rows-slider .swiper-btn-next",
		prevEl: ".partner-3-rows-slider .swiper-btn-prev",
	},
});

const homeProjectSlider = new Swiper(".home-project-slider .swiper", {
	modules: [Pagination, Navigation],
	slidesPerView: 1.5,
	spaceBetween: 20,
	breakpoints: {
		576: {
			slidesPerView: 2.5,
		},
		768: {
			slidesPerView: 3.5,
		},
		1024: {
			slidesPerView: 4.5,
		},
	},
});

const homePartnerSlider = new Swiper(".home-partner-slider .swiper", {
	modules: [Autoplay],
	slidesPerView: 2.5,
	loop: true,
	speed: 4000,
	autoplay: {
		delay: 0,
		disableOnInteraction: false,
	},
	breakpoints: {
		576: {
			slidesPerView: 4.5,
		},
		768: {
			slidesPerView: 6.5,
		},
		1024: {
			slidesPerView: 8,
		},
	},
});

const singleSlider = new LoopSlider(".single-slider", {
	1024: {
		spaceBetween: 40,
		slidesPerView: 1,
	},
});

const tripleSlider = new LoopSlider(".triple-slider", {
	576: {
		spaceBetween: 20,
		slidesPerView: 2.5,
	},
	1024: {
		spaceBetween: 40,
		slidesPerView: 3,
	},
});

const quadrupleSlider = new LoopSlider(".quadruple-slider", {
	576: {
		spaceBetween: 20,
		slidesPerView: 2.5,
	},
	768: {
		spaceBetween: 20,
		slidesPerView: 3.5,
	},
	1024: {
		spaceBetween: 40,
		slidesPerView: 4,
	},
});
